const Selects = () => {
  jQuery(function ($) {
    const SEL = '.custom-select';

    $(SEL).each(function () {
      const $select = $(this);
      const isMultiple = $select.prop('multiple');
      const selectClass = $select.hasClass('light') ? 'light' : 'dark';
      const filtersClass = $select.hasClass('cases-filters') ? 'cases-filters' : '';
      const extraDropClass = $select.data('dropdown-class') || '';

      const optionsCount = $select.find('option').filter((i, o) => o.value !== '').length;
      const placeholderText = `${optionsCount} option${optionsCount === 1 ? '' : 's'} available`;

      if (isMultiple) {
        initMulti($select, { selectClass, filtersClass, extraDropClass, optionsCount, placeholderText });
      } else {
        initSingle($select, { selectClass, filtersClass, extraDropClass, placeholderText });
      }
    });

    /* ---------- single-select: image + text ---------- */
    function initSingle($select, ctx) {
      $select.select2({
        width: '100%',
        allowClear: true,
        placeholder: ctx.placeholderText,
        minimumResultsForSearch: Infinity,
        dropdownCssClass: `dynamic-dropdown-width ${ctx.selectClass} ${ctx.filtersClass} ${ctx.extraDropClass}`.trim(),
        templateResult: optionWithImage,
        templateSelection: optionWithImage,
      });
      stripRenderedTitle($select);
      wireChangeEvents($select);
    }

    /* ---------- multi-select: single summary line + images + check + toggle ---------- */
    function initMulti($select, ctx) {
      if ($select.data('select2')) $select.select2('destroy');

      $select.select2({
        width: '100%',
        allowClear: true,
        closeOnSelect: false,
        placeholder: ctx.placeholderText,
        minimumResultsForSearch: Infinity,
        dropdownCssClass: `dynamic-dropdown-width ${ctx.selectClass} ${ctx.filtersClass} ${ctx.extraDropClass}`.trim(),
        selectionCssClass: 's2-has-summary',
        // list items: image + text + checkmark
        templateResult: optionWithImageAndCheck($select),
        // render area: we draw a single summary string ourselves (hide chips via CSS)
        templateSelection: () => '',
        sorter: items => items,
      });

      const $container = $select.next('.select2');
      const $render    = $container.find('.select2-selection__rendered').addClass('s2-summary');
      const textChosen = scripts_data.optionsChoice;
      const textAvail  = scripts_data.optionsAvailable;
      const summaryText = () => {
        const chosen = $select.find('option:selected').filter((i, o) => o.value !== '').length;
        return chosen ? `${chosen}/${ctx.optionsCount} ${textChosen}` : `${ctx.optionsCount} ${textAvail}`;
      };
      const updateSummary = () => {
        const txt = summaryText();
        $render.empty().text(txt).attr('title', txt);
      };

      // toggle already-selected item on second click
      $select.on('select2:opening', () => {
        $select.data('prev-selected', new Set(($select.val() || []).map(String)));
      });
      $select.on('select2:select', (e) => {
        const prev = $select.data('prev-selected') || new Set();
        const id   = String(e.params.data.id);
        if (prev.has(id)) {
          const current = ($select.val() || []).map(String).filter(v => v !== id);
          $select.val(current).trigger('change');
          setTimeout(() => $select.select2('open'), 0);
        }
      });

      $select.on('change select2:clear select2:unselect select2:open select2:close', updateSummary);
      updateSummary();
      stripRenderedTitle($select);
      wireChangeEvents($select);
    }

    /* ---------- templates ---------- */
    function optionWithImage(option) {
      if (!option.id) return option.text;
      const $opt = jQuery(option.element);
      const img  = $opt.data('image');
      const text = option.text || '';
      const el = document.createElement('span');
      el.className = 'option-span';
      el.innerHTML = `${img ? `<img src="${img}" class="option-img" alt="">` : ''}${text}`;
      return jQuery(el);
    }

    function optionWithImageAndCheck($select) {
      return function (option) {
        if (!option.id) return option.text;
        const $opt = jQuery(option.element);
        const img  = $opt.data('image');
        const text = option.text || '';
        const isSel = ($select.val() || []).map(String).includes(String(option.id));
        const el = document.createElement('span');
        el.className = 'option-span option-span--check';
        el.innerHTML =
          `${img ? `<img src="${img}" class="option-img" alt="">` : ''}` +
          `<span class="option-text">${text}</span>` +
          `<span class="option-check">${isSel ? '✓' : ''}</span>`;
        return jQuery(el);
      };
    }

    /* ---------- utilities ---------- */
    function stripRenderedTitle($select) {
      const $rendered = $select.next('.select2-container').find('.select2-selection__rendered');
      $rendered.removeAttr('title');
    }

    // Fire a single custom event that the filters module listens to
    function wireChangeEvents($select) {
      $select.on('change select2:select select2:unselect select2:clear', () => {
        const el = $select[0];
        el.dispatchEvent(new CustomEvent('cases:filters:changed', { bubbles: true }));
      });
    }
  });
};

export default Selects;